import { useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import {
  trackFlashSaleView,
  trackFlashSaleClick,
  trackFlashSaleAddToCart,
  trackFlashSalePurchase,
} from '../services/flashSaleAnalytics';

/**
 * Hook for tracking flash sale analytics events
 */
export function useFlashSaleAnalytics() {
  const { currentUser } = useAuth();

  const trackView = useCallback(
    async (flashSaleId: string, productId?: string, metadata?: Record<string, any>) => {
      await trackFlashSaleView(flashSaleId, productId, {
        ...metadata,
        userId: currentUser?.uid,
        timestamp: new Date().toISOString(),
      });
    },
    [currentUser?.uid]
  );

  const trackClick = useCallback(
    async (flashSaleId: string, productId: string, metadata?: Record<string, any>) => {
      await trackFlashSaleClick(flashSaleId, productId, {
        ...metadata,
        userId: currentUser?.uid,
        timestamp: new Date().toISOString(),
      });
    },
    [currentUser?.uid]
  );

  const trackAddToCart = useCallback(
    async (flashSaleId: string, productId: string, metadata?: Record<string, any>) => {
      await trackFlashSaleAddToCart(flashSaleId, productId, {
        ...metadata,
        userId: currentUser?.uid,
        timestamp: new Date().toISOString(),
      });
    },
    [currentUser?.uid]
  );

  const trackPurchase = useCallback(
    async (
      flashSaleId: string,
      productId: string,
      revenue: number,
      quantity: number = 1,
      orderId?: string,
      metadata?: Record<string, any>
    ) => {
      await trackFlashSalePurchase(flashSaleId, productId, revenue, quantity, orderId, {
        ...metadata,
        userId: currentUser?.uid,
        timestamp: new Date().toISOString(),
      });
    },
    [currentUser?.uid]
  );

  return {
    trackView,
    trackClick,
    trackAddToCart,
    trackPurchase,
  };
}

